import { FunctionComponent, ReactNode, useState } from 'react';
import { cn } from 'utils/cn';
import Modal from './Modal';

interface ModalWithActivatorProps {
  activator: ReactNode;
  children: ReactNode;
  activatorClass?: string;
  modalClass?: string;
  modalTitle: string;
}

const ModalWithActivator: FunctionComponent<ModalWithActivatorProps> = ({
  activator,
  children,
  activatorClass,
  modalClass,
  modalTitle,
}) => {
  const [show, setShow] = useState<boolean>(false);

  return (
    <>
      <div
        onClick={() => setShow(true)}
        className={cn('mx-auto w-max cursor-pointer', activatorClass)}
        role="presentation"
      >
        {activator}
      </div>
      <Modal
        modalClass={modalClass}
        modalTitle={modalTitle}
        setShow={setShow}
        show={show}
      >
        {children}
      </Modal>
    </>
  );
};

export default ModalWithActivator;
